module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/zsO2LCR2cS2MKEUcW0Y4Q-1861563fc21e4e462e2b9ed117c896d0.jpg";